import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Adjust path as needed

const ProtectedRoute = ({ children }) => {
  const { session } = useAuth();

  if (!session) {
    // User not logged in, redirect them to the login page
    // 'replace' prevents the login page from being added to the history stack
    return <Navigate to="/login" replace />;
  }

  // User is logged in, render the requested component
  return children;
};

export default ProtectedRoute;
